export interface AutomodProtection {
  key: string;
  label: string;
  description: string;
  enabledByDefault: boolean;
  threshold: number;
  action: 'warn' | 'timeout' | 'kick' | 'ban';
}

/**
 * Real defaults extracted directly from cogs/advanced_automod.py's DEFAULTS
 * dict — not invented. threshold/action are shown read-only per
 * docs/IMPLEMENTATION_PLAN.md Feature 4: v18 only exposes enable/disable via
 * commands today, so editing threshold/action is explicitly out of scope
 * until that bot-side gap closes (see docs/IMPLEMENTATION_PLAN.md
 * Dependencies/Blockers item 4).
 */
export const automodProtections: AutomodProtection[] = [
  { key: 'spam', label: 'Spam', description: 'Rapid repeated messages from one member.', enabledByDefault: true, threshold: 6, action: 'timeout' },
  { key: 'caps', label: 'Excessive caps', description: 'Messages that are mostly uppercase.', enabledByDefault: true, threshold: 70, action: 'warn' },
  { key: 'mentions', label: 'Mass mentions', description: 'Too many user/role mentions in one message.', enabledByDefault: true, threshold: 5, action: 'timeout' },
  { key: 'duplicate', label: 'Duplicate messages', description: 'The same message posted repeatedly.', enabledByDefault: true, threshold: 3, action: 'timeout' },
  { key: 'invite', label: 'Discord invites', description: 'Unsolicited server invite links.', enabledByDefault: true, threshold: 1, action: 'timeout' },
  { key: 'scam', label: 'Scam links', description: 'Known scam/phishing link patterns.', enabledByDefault: true, threshold: 1, action: 'ban' },
  { key: 'toxicity', label: 'Toxic language', description: 'Messages matching the toxic-word list.', enabledByDefault: true, threshold: 1, action: 'warn' },
  { key: 'ghostping', label: 'Ghost pings', description: 'A mention deleted shortly after sending.', enabledByDefault: true, threshold: 1, action: 'warn' },
  { key: 'raid', label: 'Raid detection', description: 'A burst of new members joining at once.', enabledByDefault: true, threshold: 3, action: 'kick' },
  { key: 'media', label: 'Unwanted media', description: 'Attachments in channels that disallow them.', enabledByDefault: false, threshold: 1, action: 'warn' },
  { key: 'linkspam', label: 'Link spam', description: 'Repeated posting of links.', enabledByDefault: true, threshold: 3, action: 'timeout' },
  { key: 'emoji_spam', label: 'Emoji spam', description: 'Messages with an excessive number of emojis.', enabledByDefault: true, threshold: 12, action: 'warn' },
];
